import { NotificationPopupNoteCost } from '@aibees/elephant/components/notification-popup-note-cost';
import { CreditUsageType } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BasicCompanyStorageInfoProps as Props } from './types';

export const BasicCompanyStorageInfo = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('BasicCompanyStorageInfo', className)}
      sx={SX.root}
    >
      <Typography variant="body5" fontWeight={400} color="common.white">
        This option allows you to save, organize, label, add to lists, or assign
        ownership to account records retrieved from a basic company search.
      </Typography>
      <Typography variant="body5" fontWeight={400} color="common.white">
        Basic company searches refer to searches not powered by AI-driven
        features. Charges of{' '}
        <NotificationPopupNoteCost
          type={CreditUsageType.ACCOUNT_STORAGE_BASIC}
        />{' '}
        Credit are only applied for new records that have not been previously
        saved. Previously saved records are free of charge
      </Typography>
    </Styled.Wrapper>
  );
});

BasicCompanyStorageInfo.displayName = 'BasicCompanyStorageInfo';
